import Highcharts from 'highcharts';

import { numberToHumanChart } from '../../../../utils/formatter';

export const COMBINED_DOWNLOADS_COLOR = '#2679FF';
export const COMBINED_REVENUE_COLOR = '#1FCC67';

export const UNIFIED_DOWNLOADS_COLOR = '#0094ff';

export const PAID_COLORS = { line: '#59a135', fill: '#a4d68a' };
export const IAP_COLORS = { line: '#de5d59', fill: '#fba5a2' };

const baseChart = {
  backgroundColor: 'transparent',
  height: 360,
};

const baseXAxis = {
  type: 'datetime',
  labels: { format: '{value:%b %e}' },
};

const baseYAxis = {
  title: { text: '' },
  min: 0,
  minRange: 0.1,
  tickAmount: 5,
};

const tooltip = {
  backgroundColor: 'white',
  borderWidth: 1,
  borderColor: '#e1e5eb',
  borderRadius: 8,
  padding: 8,
  shared: true,
  style: {
    color: '#555F77',
    fontSize: '12px',
  },
  valueDecimals: 0,
  useHTML: true,
  outside: true,
};

const humanLabelFormatter = (value) =>
  numberToHumanChart(value, { precision: 1, strip_insignificant_zeros: true });

export const combinedChartConfig = {
  chart: { ...baseChart, type: 'spline' },
  title: { text: '' },
  credits: { enabled: false },
  legend: {
    enabled: true,
    align: 'center',
    verticalAlign: 'bottom',
    layout: 'horizontal',
    itemStyle: { fontWeight: 'bold', color: '#555F77', fontSize: 12 },
  },
  xAxis: { ...baseXAxis, crosshair: { width: 1, color: '#979797' } },
  yAxis: [
    {
      ...baseYAxis,
      labels: {
        style: { color: COMBINED_DOWNLOADS_COLOR },
        formatter() {
          return humanLabelFormatter(this.value);
        },
      },
    },
    {
      ...baseYAxis,
      labels: {
        reserveSpace: true,
        style: {
          color: COMBINED_REVENUE_COLOR,
          fontSize: 12,
        },
        formatter() {
          return `$${humanLabelFormatter(this.value)}`;
        },
      },
      opposite: true,
    },
  ],
  plotOptions: { series: { marker: { enabled: false } } },
  tooltip,
};

export const unifiedDownloadsChartConfig = {
  chart: { ...baseChart, type: 'spline' },
  title: { text: '' },
  credits: { enabled: false },
  legend: {
    enabled: true,
    align: 'center',
    verticalAlign: 'bottom',
    layout: 'horizontal',
    itemStyle: { fontWeight: 'bold', color: '#555F77', fontSize: 12 },
  },
  xAxis: baseXAxis,
  yAxis: {
    ...baseYAxis,
    labels: {
      style: { color: '#848ea1' },
      formatter() {
        return humanLabelFormatter(this.value);
      },
    },
  },
  plotOptions: { series: { marker: { enabled: false } } },
  tooltip,
  noData: { style: { fontSize: '16px', fontWeight: 'normal', color: '#848ea1' } },
};

export const unifiedRevenueChartConfig = {
  chart: { ...baseChart, type: 'areaspline' },
  title: { text: '' },
  credits: { enabled: false },
  legend: {
    enabled: true,
    align: 'center',
    verticalAlign: 'bottom',
    layout: 'horizontal',
    itemStyle: { fontWeight: 'bold', color: '#555F77', fontSize: 12 },
  },
  xAxis: { ...baseXAxis, crosshair: { width: 1, color: '#979797' } },
  yAxis: {
    ...baseYAxis,
    labels: {
      style: { color: '#848ea1' },
      formatter() {
        return `$${humanLabelFormatter(this.value)}`;
      },
    },
  },
  plotOptions: {
    areaspline: { stacking: 'normal', lineWidth: 1 },
    series: { marker: { enabled: false } },
  },
  tooltip: {
    ...tooltip,
    shared: true,
    split: true,
    useHTML: true,
    formatter() {
      const date = Highcharts.dateFormat('%b %e, %Y', this.x);
      const total = this.points.reduce((sum, p) => sum + (p.y || 0), 0);
      const totalHtml = `${date}<br/>Total: <b>$${Highcharts.numberFormat(total, 0, '.', ',')}</b>`;
      const seriesHtml = this.points
        .map(
          (p) => `<span style="color:${p.series.color}">●</span> ${p.series.name} <b>$${p.y}</b>`
        )
        .join('<br/>');

      return [totalHtml, seriesHtml];
    },
  },
};
